import { useLocation } from "react-router-dom";

const useIsActivePath = (path: string): boolean => {
  const { pathname } = useLocation();
  if (path.endsWith("*")) {
    path = path.slice(0, -1);
    return (
      pathname.startsWith(path) ||
      pathname.startsWith("/" + path) ||
      pathname === path
    );
  }
  if (path.startsWith("/")) {
    return pathname === path;
  }
  return pathname.slice(1) === path;
};

export default useIsActivePath;
